module.exports = "/assets/data/d8ce8be73ebe7070dace3be238647cef-DT3.data.json";